<template>
  <v-app>
    <component :is="this.$store.state.layout"></component>
  </v-app>
</template>

<script>
import Vue from 'vue';
import "./assets/main.scss";

export default Vue.extend({
  name: 'Chronos_App',

  components: {
    // HelloWorld,
  },

  data(){
    return {}
  },
  mounted() {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.$vuetify.theme.dark = mediaQuery.matches;

    // Escucha cambios en tiempo real
    mediaQuery.addEventListener('change', (e) => {
      this.$vuetify.theme.dark = e.matches;
    });
  }
});
</script>
<style>
  .uppercase--text {
    text-transform: uppercase;
  }
</style>
